import { z } from 'zod';
import { payableDataSchema } from '../../Payable.js';
import { coverageFulfillmentServiceConfigSchema } from '../configurations/CoverageFulfillmentServiceConfig.js';
import { servicesProviderGenericDataSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderCoverageFulfillmentDataSchema = servicesProviderGenericDataSchema
    .merge(payableDataSchema)
    .extend({
    config: z.object({
        [Services.COVERAGE_FULFILLMENT]: coverageFulfillmentServiceConfigSchema,
    }),
});

export { servicesProviderCoverageFulfillmentDataSchema };
//# sourceMappingURL=ServicesProviderCoverageFulfillmentData.js.map
